import ColorPickerButton from 'molecules/ColorPickerButton'
import ColorBucketIcon from 'atoms/icons/ColorBucketIcon'
import FontIcon from 'atoms/icons/FontIcon'
import { ItemData, ItemDataTextProps } from 'store/types'

type Props = {
  item: ItemData<'text'>
  onPropsChange: (props: ItemDataTextProps) => void
}

function PostTextTools({ item, onPropsChange }: Props) {
  return (
    <div className='flex flex-col gap-2'>
      <div className='flex flex-row flex-wrap gap-2'>
        <ColorPickerButton
          leftElement={<FontIcon size={18} />}
          color={item.props.color}
          onChangeColor={color =>
            onPropsChange({
              ...item.props,
              color
            })
          }
        />
        <ColorPickerButton
          leftElement={<ColorBucketIcon size={18} />}
          color={item.props.backgroundColor}
          onChangeColor={backgroundColor =>
            onPropsChange({
              ...item.props,
              backgroundColor
            })
          }
        />
        <input
          id='bold'
          type='checkbox'
          className='btn btn-outline btn-neutral btn-sm btn-icon-font-bold'
          checked={item.props.bold}
          onChange={e =>
            onPropsChange({
              ...item.props,
              bold: e.target.checked
            })
          }
        />
        <input
          id='italic'
          type='checkbox'
          className='btn btn-outline btn-neutral btn-sm btn-icon-font-italic'
          checked={item.props.italic}
          onChange={e =>
            onPropsChange({
              ...item.props,
              italic: e.target.checked
            })
          }
        />
        <input
          id='underline'
          type='checkbox'
          className='btn btn-outline btn-neutral btn-sm btn-icon-font-underline'
          checked={item.props.underline}
          onChange={e =>
            onPropsChange({
              ...item.props,
              underline: e.target.checked
            })
          }
        />
        <input
          id='line-through'
          type='checkbox'
          className='btn btn-outline btn-neutral btn-sm btn-icon-font-line-through'
          checked={item.props.lineThrough}
          onChange={e =>
            onPropsChange({
              ...item.props,
              lineThrough: e.target.checked
            })
          }
        />
      </div>
      <textarea
        className='w-full textarea textarea-bordered'
        placeholder='Escreva aqui'
        value={item.props.text}
        onChange={e =>
          onPropsChange({
            ...item.props,
            text: e.target.value
          })
        }
      />
    </div>
  )
}

export default PostTextTools
